import PropTypes from 'prop-types'

const SpaceLandingTitle = ({ componentClass: Component, children, description }: any) => (
  <div>
    <Component>{children}</Component>
    <p className="sub-header">{description}</p>
  </div>
)

SpaceLandingTitle.displayName = 'SpaceLandingTitle'

SpaceLandingTitle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)]),
  componentClass: PropTypes.node,
  description: PropTypes.string
}

SpaceLandingTitle.defaultProps = {
  children: null,
  componentClass: 'h2',
  description: ''
}

export default SpaceLandingTitle
